// extracted by mini-css-extract-plugin
export default {"containerPagination":"CustomPagination_containerPagination__ZfWID","prevIcon":"CustomPagination_prevIcon__6Q2yP","active":"CustomPagination_active__bTErv"};